import { render, staticRenderFns } from "./RelationValue.vue?vue&type=template&id=3db8c3c9"
import script from "./RelationValue.vue?vue&type=script&lang=ts"
export * from "./RelationValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports